import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface ListingVideoResource {
  id: number;
  url: string;
  name: string;
  fileSize: number;
  length: number;
  title: string;
  author: string;
}

type Order = number;

export type Videos = ListingVideoResource[];

export default (makeCall: MakeCall) => (listingId: number, order: Order[]) =>
  makeCall<Videos>('PUT', `/api/v2/listing/${listingId}/videos`, {
    data: order,
  });
